import {
  brandCaptionLowerThird,
  BrandCaptionLowerThird,
  brandEntityId,
  BrandEntityId,
  RoomId,
  roomId
} from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class RoomBrandCaptionLowerThirdCreateVO {
  private static validation = JsonSchemaValidator.compile(
    RoomBrandCaptionLowerThirdCreateVO.validationSchema()
  );

  constructor(readonly value: RoomBrandCaptionLowerThird) {
    JsonSchemaValidator.assert(
      RoomBrandCaptionLowerThirdCreateVO.validation,
      value
    );
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["roomId", "brandId", "caption"],
      properties: {
        roomId,
        brandId: brandEntityId,
        caption: brandCaptionLowerThird
      },
      additionalProperties: false
    };
  }
}

interface RoomBrandCaptionLowerThird {
  roomId: RoomId;
  brandId: BrandEntityId;
  caption: BrandCaptionLowerThird;
}
